
let  dialog =  {
    addUser: 'Add User',
    editUser: 'Edit User',
    userInfo: 'Userinfo',
    username: 'User Name',
    password: 'Password',
    confirmPass: 'Confirm Password',
    userGroup: 'User Group',
    Superior: 'Superior',
    mobile: 'Mobile',
    checkGroup: 'Check Account Group',
    checkMobile: 'Check Contact',
    lock: 'Enable',
    /* 添加用户组 */
    addUserGroup: 'Add User Group Information',
    groupName: 'User Group Name',
    groupDesc: 'User Group Description',
    /* 修改用户 */
    systemAdmin: 'System Admin',
    introducedBroker: 'Introduced broker',
    /* 修改用户组 */
    editGroupInfo: 'Modify User Group Information',
    /* 修改用户组权限 */
    editUserAuth: 'Modify User Group permissions',
    /* 添加下级用户 */
    addLowerUser: 'Add Lower User',
    /* 修改出金申请信息 */
    editWithdraw: 'Modify Withdraw Info',
    editBankcardInfo: 'Modify Bankcard Info'
}

export default dialog;




















































// WEBPACK FOOTER //
// ./src/i18n/english/dialog.js